import React from 'react';
import TaskDueDate from './TaskDueDate'; // Importamos el componente de fecha

// Recibe la tarea y las funciones de manipulación por 'props'
const TaskItem = ({ task, onToggleComplete, onDeleteTask, onUpdateTaskDate }) => { // Recibe la nueva 'prop'
    return (
        <li key={task.id} className={task.completed ? 'completed' : ''}>
            {/* Cuando se hace clic en el span, llama la función recibida por 'props' */}
            <span onClick={() => onToggleComplete(task.id)}>
                {task.text}
            </span>

            {/* Integración del componente de fecha */}
            <TaskDueDate
                taskId={task.id}
                dueDate={task.dueDate}
                onUpdateTaskDate={onUpdateTaskDate}
            />

            <button onClick={() => onDeleteTask(task.id)}>Eliminar</button>
        </li>
    );
};

export default TaskItem;